import { SlashCommand } from './types';

export const hubCommands: SlashCommand[] = [
    { id: 'news', name: 'Latest News', trigger: '/news', description: 'Fetch latest news via Hub', category: 'Research', icon: 'fa-newspaper', mode: 'tool', tool: 'hub-news', prefix: 'latest news about: ', integration: 'All-Access Hub' }
];
